export const LOW_BATTERY_THRESHOLD = 20;
